import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import HomeCard from '../../components/HomeCard';

const styles = css`
  margin-top: 20px;
  .HomesResults_loadMoreWrapper {
    margin-top: 42px;
    display: flex;
    justify-content: center;
  }
  .HomesResults_loadMore {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.014286em;
    line-height: 1;
    background-color: white;
    background-image: none;
    width: 160px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #E9E9E9;
    border-radius: 3px;
    padding: 0;
    cursor: pointer;
    @media (min-width: 768px) {
      font-size: 14px;
      width: 200px;
      height: 50px;
      border-radius: 4px;
    }
  }
  .HomesResults_cardWrapper {
    max-width: 420px;
    @media (min-width: 620px) {
      max-width: none;
      padding-left: 7.5px;
      padding-right: 7.5px;
    }
    @media (min-width: 768px) {
      padding-left: 15px;
      padding-right: 15px;
    }
    @media (min-width: 992px) {
      width: 33.333333%;
    }
  }
  .HomesResults_card {
    margin-bottom: 30px;
  }
`;


class HomesResults extends React.Component {
  constructor(props) {
    super(props);
    if (global.window !== undefined && global.document !== undefined) {
      const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      this.loadMoreNumber = viewportWidth < 992 ? 3 : 9;
      this.initialLimit = viewportWidth < 992 ? 6 : 9;
    } else {
      this.loadMoreNumber = 9;
      this.initialLimit = 6;
    }
    this.state = {
      show: this.initialLimit,
    };
  }

  loadMore = () => {
    this.setState({
      show: this.state.show + this.loadMoreNumber,
    });
  }

  render() {
    const { homes, sort, option } = this.props;
    const { show } = this.state;
    let filteredHomes;
    if (option === 'Resale Homes') {
      filteredHomes = homes.filter(resaleHome => resaleHome.resale_home);
    } else if (option === 'New Homes') {
      filteredHomes = homes.filter(newHome => !newHome.resale_home);
    } else { filteredHomes = homes; }
    return (
      <div className={styles}>
        <div className="HomesResults_cardsWrapper row justify-content-center">
          {
            orderBy(filteredHomes, sort.field, get(sort, 'dir', 'asc')).slice(0, show).map(home => (
              <div key={home._id} className="HomesResults_cardWrapper col-12 col-lg-6 col-xl-4">
                <HomeCard className="HomesResults_card" home={home} />
              </div>
            ))
          }
        </div>
        {
          homes.length > show &&
          <div className="HomesResults_loadMoreWrapper">
            <button
              className="HomesResults_loadMore"
              type="button"
              onClick={this.loadMore}
            >
              {`See the Next ${Math.min(this.loadMoreNumber, homes.length - show)} Homes`}
            </button>
          </div>
        }
      </div>
    );
  }
}

HomesResults.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
  option: PropTypes.string,
};
HomesResults.defaultProps = {
  option: '',
};
export default withData({
  homes: true,
})(HomesResults);



// WEBPACK FOOTER //
// ./src/pages/Homes/HomesResults.js